export default {"src":"/_next/static/media/top_icon_active.252da50c.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};